$(document).ready(function () {
  // Select all radio buttons with a specific name, e.g., 'myRadioGroup'
  // Select the element with dynamic ID
  var target = document.querySelector("[id^='price-template--'][id$='__main']");

  if (target) {
    //for the first time load
    onHiddenRemoved();
    // Create a MutationObserver to watch for class changes
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          if (target.classList.contains("hidden")) {
            // Hidden class was added
            onHiddenAdded();
          } else {
            // Hidden class was removed
            onHiddenRemoved();
          }
        }
      });
    });

    observer.observe(target, { attributes: true });
  }

  // Define your functions
  function onHiddenAdded() {
    // Trigger your logic when 'hidden' is added
    console.log("'hidden' class added");
    $(".product__text.inline-richtext.subtitle").show();
  }

  function onHiddenRemoved() {
    // Trigger your logic when 'hidden' is removed
    $(".product__text.inline-richtext.subtitle").hide();
  }
});
